import React from 'react';
import MapView from './components/MapView';
import './App.css';

// 地图中心点坐标：经度 121.054655, 纬度 31.111885
const MAP_CENTER = [121.054655, 31.111885];

// 朱家角手绘地图四角经纬度坐标
const MAP_BOUNDS = {
  sw: [121.0423610868, 31.0992721809],  // 西南
  se: [121.0652513693, 31.0992721809],  // 东南
  nw: [121.0423610868, 31.1256812637],  // 西北
  ne: [121.0652513693, 31.1256812637]   // 东北
};

// 手绘地图底色
const BACKGROUND_COLOR = '#FCF6D4';

function App() {
  return (
    <div className="App">
      <MapView
        center={MAP_CENTER}
        zoom={16}
        apiKey="afb5aad288c708627b93225378003c95"
        bounds={MAP_BOUNDS}
        backgroundColor={BACKGROUND_COLOR}
      />
    </div>
  );
}

export default App;
